<template>
  <a-modal
    :title="isEdit ? '编辑应用' : '上传应用'"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="700"
    :okButtonProps="{ props: { disabled: apkUploading } }"
  >
    <a-form :form="form">
      <a-form-item label="应用名称" :label-col="{ sm: 8, md: 5 }" :wrapper-col="{ sm: 8, md: 12 }">
        <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入应用名称' }] }]" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="应用文件" :label-col="{ sm: 8, md: 5 }" :wrapper-col="{ sm: 8, md: 12 }">
        <a-upload
          name="file"
          :before-upload="beforeUpload"
          :show-upload-list="false"
          :accept="'.apk'"
          @change="handleFileChange"
        >
          <a-button>
            <a-icon type="upload" />
            上传
          </a-button>
        </a-upload>
        <span class="upload-hint">格式为 APK</span>
        <div v-if="apkFileName || apkUploading" class="file-info">
          <a-progress v-if="apkUploading" :percent="apkUploadProgress.toFixed(2)" status="active" size="small" style="flex: 1; margin: 0" />
          <template v-else>
            <a-icon type="file" />
            <span>{{ apkFileName }}</span>
            <a-icon type="close" class="delete-icon" @click="removeApkFile" />
          </template>
        </div>
      </a-form-item>

      <a-form-item label="应用图标" :label-col="{ sm: 8, md: 5 }" :wrapper-col="{ sm: 8, md: 12 }">
        <div class="icon-upload-wrapper">
          <!-- <a-upload
            name="icon"
            :before-upload="beforeUploadIcon"
            :show-upload-list="false"
            accept=".jpg,.png"
            list-type="picture-card"
            @change="handleIconChange"
            :class="{ 'icon-uploaded': iconUrl }"
          >
            <div v-if="!iconUrl" class="upload-trigger">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传</div>
            </div>
            <div class="preview-wrapper">
              <img :src="iconUrl" alt="应用图标" class="icon-preview" />
              <div class="overlay">
                <a-icon type="eye" class="preview-icon" @click.stop="previewIcon" />
                <a-icon type="delete" class="delete-icon" @click.stop="removeIcon" />
              </div>
            </div>
          </a-upload>
          <span class="upload-hint">格式为 jpg / png，建议尺寸 200*200</span> -->
          <div v-if="iconUploadUrl" class="preview-wrapper">
            <img :src="iconUploadUrl.downloadUrl" alt="应用图标" class="icon-preview" />
            <div class="overlay">
              <a-icon type="eye" class="preview-icon" @click.stop="previewIcon" />
            </div>
          </div>
          <div v-else>
            请先上传apk文件
          </div>
        </div>
      </a-form-item>

      <a-form-item label="包名" :label-col="{ sm: 8, md: 5 }" :wrapper-col="{ sm: 8, md: 12 }">
        <a-input v-decorator="['packageName', { rules: [{ required: true, message: '请输入包名' }] }]" placeholder="请输入" />
      </a-form-item>
    </a-form>

    <!-- 图标预览模态框 -->
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible = false"
      width="500px"
      centered
    >
      <img :src="previewImage" style="width: 100%" alt="预览" />
    </a-modal>
  </a-modal>
</template>

<script>
import { createApplication, updateApplication, uploadFile, uploadV2ApkFile } from '@/api/configManage'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      iconUrl: '', // 图标URL（上传后的地址）
      iconFile: null, // 图标文件对象
      iconUploadUrl: '', // 图标上传后的真实URL
      apkFile: null, // APK文件对象
      apkFileName: '', // APK文件名
      apkUploadUrl: '', // APK上传后的真实URL
      apkUploading: false, // APK文件上传中状态
      apkUploadProgress: 0, // APK上传进度
      isEdit: false, // 是否编辑模式
      currentAppId: null, // 当前编辑的应用ID
      previewVisible: false, // 预览弹窗显示状态
      previewImage: '' // 预览图片地址
    }
  },
  methods: {
    handleOk () {
      if (this.apkUploading) {
        this.$message.warning('APK文件正在上传中，请稍候...')
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          const trimmedValues = Object.keys(values).reduce((acc, key) => {
            const value = values[key]
            acc[key] = typeof value === 'string' ? value.trim() : value
            return acc
          }, {})
          // 提交数据（文件已在选择时上传）
          this.submitData(trimmedValues)
        }
      })
    },
    // 提交数据（仅提交，不再上传文件）
    submitData (values) {
      // 构建提交数据，使用已上传的URL
      const submitData = {
        ...values,
        ...(this.iconUploadUrl && { icon: this.iconUploadUrl }),
        ...(this.apkUploadUrl && { apk: this.apkUploadUrl })
      }

      // 编辑模式添加 id
      if (this.isEdit && this.currentAppId) {
        submitData.id = this.currentAppId
      }

      const apiCall = this.isEdit ? updateApplication : createApplication
      const successMsg = this.isEdit ? '应用更新成功' : '应用创建成功'

      apiCall(submitData).then(res => {
        if (res.code === 1) {
          this.$message.success(successMsg)
          this.$emit('ok', submitData)
          this.handleCancel()
        } else {
          this.$message.error(res.msg || (this.isEdit ? '应用更新失败' : '应用创建失败'))
        }
      }).catch(err => {
        this.$message.error(this.isEdit ? '应用更新失败' : '应用创建失败')
        console.error('应用操作失败:', err)
      })
    },

    handleCancel () {
      this.resetForm()
      this.$emit('cancel')
    },

    resetForm () {
      this.form.resetFields()
      this.iconUrl = ''
      this.iconFile = null
      this.iconUploadUrl = ''
      this.apkFile = null
      this.apkFileName = ''
      this.apkUploadUrl = ''
      this.apkUploading = false
      this.apkUploadProgress = 0
      this.isEdit = false
      this.currentAppId = null
      this.previewVisible = false
      this.previewImage = ''
    },

    // APK文件上传前校验 - 选择文件时直接上传
    beforeUpload (file) {
      const isAPK = file.type === 'application/vnd.android.package-archive'

      if (!isAPK) {
        this.$message.error('只能上传 APK 文件!')
        return false
      }
      // 保存文件信息用于显示
      this.apkFile = file
      this.apkFileName = file.name

      // 设置上传中状态
      this.apkUploading = true

      // 直接上传文件
      this.uploadApkFile(file)

      // 阻止自动上传
      return false
    },

    // 上传APK文件
    async uploadApkFile (file) {
      this.apkUploading = true
      this.apkUploadProgress = 0

      // 模拟进度
      const progressTimer = setInterval(() => {
        if (this.apkUploadProgress < 90) {
          this.apkUploadProgress += Math.random() * 15
          if (this.apkUploadProgress > 90) {
            this.apkUploadProgress = 90
          }
        }
      }, 200)

      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await uploadV2ApkFile(formData)
        clearInterval(progressTimer)
        this.apkUploadProgress = 100
        if (res.code === 1) {
          this.apkUploadUrl = res.data.apk
          this.iconUploadUrl = res.data.icon
          this.form.setFieldsValue({
            packageName: res.data.packageName
          })
          this.$message.success('APK 文件上传成功')
          setTimeout(() => {
            this.apkUploading = false
          }, 500)
        } else {
          this.$message.error(res.msg || 'APK 文件上传失败')
          this.apkFile = null
          this.apkFileName = ''
          this.apkUploading = false
          this.iconUploadUrl = ''
        }
      } catch (error) {
        clearInterval(progressTimer)
        this.$message.error('APK 文件上传失败')
        this.apkFile = null
        this.apkFileName = ''
        console.error('APK 文件上传失败:', error)
      } finally {
        this.apkUploading = false
      }
    },

    // 图标上传前校验 - 选择文件时直接上传
    beforeUploadIcon (file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'

      if (!isImage) {
        this.$message.error('只能上传 JPG 或 PNG 图片!')
        return false
      }

      // 保存图标文件用于上传
      this.iconFile = file

      // 生成本地预览URL
      const reader = new FileReader()
      reader.onload = (e) => {
        this.iconUrl = e.target.result
      }
      reader.readAsDataURL(file)

      // 直接上传图标
      this.uploadIconFile(file)

      // 阻止自动上传
      return false
    },

    // 上传图标文件
    async uploadIconFile (file) {
      try {
        const formData = new FormData()
        formData.append('file', file)
        const res = await uploadFile(formData, 1)
        if (res.code === 1) {
          this.iconUploadUrl = res.data
          this.$message.success('图标上传成功')
        } else {
          this.$message.error(res.msg || '图标上传失败')
          this.iconUrl = ''
          this.iconFile = null
        }
      } catch (error) {
        this.$message.error('图标上传失败')
        this.iconUrl = ''
        this.iconFile = null
        console.error('图标上传失败:', error)
      }
    },

    // APK文件变化处理
    handleFileChange (info) {
      // 文件已经在 beforeUpload 中处理，这里可以不做额外操作
      console.log('APK文件已选择:', info.file.name)
    },

    // 图标变化处理
    handleIconChange (info) {
      // 已经在 beforeUploadIcon 中处理
    },

    // 预览图标
    previewIcon () {
      if (this.iconUploadUrl) {
        this.previewImage = this.iconUploadUrl.downloadUrl
        this.previewVisible = true
      }
    },

    // 删除图标
    removeIcon () {
      this.$confirm({
        title: '确认删除',
        content: '确定要删除应用图标吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.iconUrl = ''
          this.iconFile = null
          this.iconUploadUrl = ''
          this.form.setFieldsValue({ icon: undefined })
          this.$message.success('已删除')
        }
      })
    },

    // 删除APK文件
    removeApkFile () {
      this.$confirm({
        title: '确认删除',
        content: '确定要删除已上传的APK文件吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.apkFile = null
          this.apkFileName = ''
          this.apkUploadUrl = ''
          this.apkUploading = false
          this.apkUploadProgress = 0
          this.$message.success('已删除')
        }
      })
    },

    // 加载数据（编辑时使用）
    load (app) {
      console.log('app', app)
      if (app) {
        // 设置编辑状态
        this.isEdit = true
        this.currentAppId = app.id

        this.form.setFieldsValue({
          name: app.name,
          packageName: app.packageName,
          className: app.className
        })

        // 设置图标回显
        if (app.icon && app.icon.downloadUrl) {
          const iconUrl = app.icon.downloadUrl
          this.iconUrl = iconUrl
          this.iconUploadUrl = app.icon
          this.iconFile = app.icon
        }

        // 设置APK文件信息
        if (app.apk.name) {
          this.apkFileName = app.apk.name
          this.apkUploadUrl = app.apk
          this.apkFile = app.apk
        }
      }
    },

    // 清空表单（外部调用）
    clear () {
      this.resetForm()
    }
  }
}
</script>

<style scoped>
.upload-hint {
  margin-left: 10px;
  font-size: 12px;
  color: #999;
}

/* 文件信息显示 */
.file-info {
  margin-top: 8px;
  padding: 4px 8px;
  background: #f5f5f5;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.file-info .delete-icon {
  cursor: pointer;
  color: #999;
  transition: color 0.3s;
}

.file-info .delete-icon:hover {
  color: #ff4d4f;
}

/* 图标上传组件样式 */
.icon-upload-wrapper {
  display: flex;
  flex-direction: column;
}

.icon-upload-wrapper :deep(.ant-upload-picture-card-wrapper) {
  margin-bottom: 8px;
}

.icon-upload-wrapper :deep(.ant-upload.ant-upload-select-picture-card) {
  width: 104px;
  height: 104px;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s;
}

/* 上传触发区域样式 */
.upload-trigger {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.upload-trigger .ant-icon {
  font-size: 24px;
  color: #999;
}

.upload-trigger .ant-upload-text {
  margin-top: 8px;
  color: #999;
}

/* 已上传图标的预览样式 */
.preview-wrapper {
  position: relative;
  width: 100px;
  height: 100px;
}

.icon-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  opacity: 0;
  transition: opacity 0.3s;
}

.preview-wrapper:hover .overlay {
  opacity: 1;
}

.overlay .preview-icon,
.overlay .delete-icon {
  font-size: 20px;
  color: white;
  cursor: pointer;
  transition: transform 0.2s;
}

.overlay .preview-icon:hover,
.overlay .delete-icon:hover {
  transform: scale(1.1);
}

.overlay .preview-icon:hover {
  color: #1890ff;
}

.overlay .delete-icon:hover {
  color: #ff4d4f;
}
</style>
